import { styled } from '@mui/joy';

const PageContainer = styled('article')(({ theme }) => ({
  position: 'relative',
  height: `calc(100vh - 56px)`,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  '@media (max-width: 1200px)': {
    padding: theme.spacing(2),
  },
  backgroundColor: theme.palette.isDarkMode
    ? theme.palette.neutral[50]
    : theme.palette.common.white,
}));

export const PageListContainer = styled(PageContainer)(({ theme }) => ({
  padding: theme.spacing(3),
  paddingBottom: 0,
  overflow: 'auto',
}));

export const PageDetailsContainer = styled(PageContainer)(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(3)} 0`,
  overflow: 'hidden',
}));
